import { Node, mergeAttributes } from "@tiptap/core";
import type { Node as ProseMirrorNode } from "@tiptap/pm/model";

interface MarkdownState {
  write(content: string): void;
  renderContent(node: ProseMirrorNode): void;
  ensureNewLine(): void;
  closeBlock(node: ProseMirrorNode): void;
}

export const EmailOnly = Node.create({
  name: "emailOnly",
  group: "block",
  content: "block+",
  defining: true,

  parseHTML() {
    return [{ tag: "div[data-email-only]" }, { tag: "email" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-email-only": "",
        class: "email-only",
      }),
      0,
    ];
  },

  addStorage() {
    return {
      markdown: {
        serialize(state: MarkdownState, node: ProseMirrorNode) {
          state.write("<email>\n\n");
          state.renderContent(node);
          state.ensureNewLine();
          state.write("</email>");
          state.closeBlock(node);
        },
        parse: {},
      },
    };
  },
});
